// -- ACTIONS --
// App Actions
export const IS_EMPTY_ACCOUNT = 'IS_EMPTY_ACCOUNT';
export const SET_IS_CONNECT = 'SET_IS_CONNECT';
export const SET_TEMPLATE_ACCOUNT = 'SET_TEMPLATE_ACCOUNT';
export const GET_CONFIG = 'GET_CONFIG';
export const GET_USER_DATA = 'GET_USER_DATA';
export const ADD_MEDIAS_DATA = 'ADD_MEDIAS_DATA';
export const UPDATE_MEDIAS_PAGINATION = 'UPDATE_MEDIAS_PAGINATION';
export const ON_CONNECT = 'ON_CONNECT';
export const SET_APP_STATE = 'SET_APP_STATE';
export const ON_CONNECT_BUSINESS = 'ON_CONNECT_BUSINESS';
export const SET_PROFILE_HEADER_HEIGHT = 'SET_PROFILE_HEADER_HEIGHT';
export const SET_TITLE_HASHTAG_HEIGHT = 'SET_TITLE_HASHTAG_HEIGHT';
export const IS_MOBILE = 'IS_MOBILE';
export const IS_APP_LOADING = 'IS_APP_LOADING';
export const ON_DISCONNECT = 'ON_DISCONNECT';
export const PREVIEW_HOVER_MODE = 'PREVIEW_HOVER_MODE';
export const SET_STORY = 'SET_STORY';
export const MEDIAS_DATA_ERROR = 'MEDIAS_DATA_ERROR';
export const SET_COMMENTS = 'SET_COMMENTS';
export const ADD_COMMENTS = 'ADD_COMMENTS';
export const SET_COMMENTS_PAGING = 'SET_COMMENTS_PAGING';
export const COMMENTS_LOADING = 'COMMENTS_LOADING';
export const SET_HASHTAG_DATA = 'SET_HASHTAG_DATA';
export const ADD_HASHTAGS_DATA = 'ADD_HASHTAGS_DATA';
export const UPDATE_MEDIA_LINKS = 'UPDATE_MEDIA_LINKS';
export const HASHTAGS_LOADING = 'HASHTAGS_LOADING';
export const UPDATE_STORY_PROGRESS = 'UPDATE_STORY_PROGRESS';
export const ON_CHANGE_VIEW_MODE = 'ON_CHANGE_VIEW_MODE';
export const LOGIN_ERROR = 'LOGIN_ERROR';
// Mobile Actions
export const ON_CLICK_SHOW_MORE_MOBILE = 'ON_CLICK_SHOW_MORE_MOBILE';
// Pro Gallery Actions
export const UPDATE_GALLERY_LOAD_MORE = 'UPDATE_GALLERY_LOAD_MORE';
export const ON_RESTART_GALLERY = 'ON_RESTART_GALLERY';
export const ON_CHANGE_HASHTAG_GALLERY = 'ON_CHANGE_HASHTAG_GALLERY';
export const ON_CHANGE_FEED_GALLERY = 'ON_CHANGE_FEED_GALLERY';
// Expand Actions
export const ON_CLICK_MEDIA = 'ON_CLICK_MEDIA';
export const SET_EXPAND_STATE = 'SET_EXPAND_STATE';
export const EXPAND_IS_LOADING_MORE_MEDIAS = 'EXPAND_IS_LOADING_MORE_MEDIAS';
export const EXPAND_ON_ADD_MEDIAS = 'EXPAND_ON_ADD_MEDIAS';
export const SET_MEDIA_LINKS = 'SET_MEDIA_LINKS';
export const SET_MEDIA_LINKS_LOADING = 'SET_MEDIA_LINKS_LOADING';
export const SET_POSTS = 'SET_POSTS';
export const SET_STORIES = 'SET_STORIES';
// Settings Action
export const ON_CHANGE_STYLE_PARAM = 'ON_CHANGE_STYLE_PARAM';
export const ON_TEXT_CHANGE = 'ON_TEXT_CHANGE';
export const UPDATE_HASHTAG = 'UPDATE_HASHTAG';
export const ON_ADD_HASHTAG = 'ON_ADD_HASHTAG';
export const ON_ADD_DEFAULT_HASHTAG = 'ON_ADD_DEFAULT_HASHTAG';

// URL
export const URL_GET_CONFIG = 'settings/config';
export const URL_TEMPLATE_GET_USER = 'instagram/templates/user';
export const URL_TEMPLATE_GET_MEDIAS = 'instagram/templates/medias';
export const URL_DB_GET_USER = 'data/getUser';
export const URL_FB_GET_USER = 'facebook/getUser';
export const URL_FB_GET_MEDIAS = 'facebook/getMedias';
export const URL_FB_GET_STORIES = 'facebook/getStories';
export const URL_FB_GET_COMMENTS = 'facebook/getComments';
export const URL_FB_SEARCH_HASHTAGS = 'facebook/searchHashtag';
export const URL_FB_GET_HASHTAGS = 'facebook/getHashtag';
export const URL_INSTAGRAM_GET_USER = 'instagram/self';
export const URL_INSTAGRAM_GET_MEDIAS = 'instagram/medias';
export const URL_LINKS_GET_SETTINGS = 'media/settings_sync';
export const URL_LINKS_GET_COUNT = 'media/count';
export const URL_LINKS_GET_MEDIA_LINKS = 'media_links/';

// Layout
export const DEFAULT_AVATAR_SIZE_DESKTOP = 60;
export const DEFAULT_AVATAR_PADDING_TOP_BOTTOM = 0;
export const DEFAULT_AVATAR_PADDING_LEFT_RIGHT = 0;
// === ADD MOBILE SIZES
export const DEFAULT_AVATAR_PADDING_TOP_BOTTOM_MOBILE = 0;
export const DEFAULT_AVATAR_PADDING_LEFT_RIGHT_MOBILE = 0;
export const DEFAULT_AVATAR_SIZE_MOBILE = 36;
export const DEFAULT_PADDING_HEADER_MOBILE = 20;
export const DEFAULT_TOP_PADDING_HEADER_DESK = 32;
export const DEFAULT_LEFT_PADDING_HEADER_DESK = 20;
export const PROFILE_LAYOUT_POSITIN = 'profileComponentPosition';
export const FEED_LAYOUT_POSITIN = 'feedComponentPosition';
export const HASHTAG_LAYOUT_POSITIN = 'hashtagComponentPosition';
export const M_PROFILE_LAYOUT_POSITIN = 'm_profileComponentPosition';
export const M_FEED_LAYOUT_POSITIN = 'm_feedComponentPosition';
export const M_HASHTAG_LAYOUT_POSITIN = 'm_hashtagComponentPosition';

// Global
export const TABLET_WIDTH = 768;
export const DESK_SMALL_WIDTH = 480;
export const MAX_PROFILE_INFO_WIDTH_DESKTOP = 606;
export const DEFAULT_HASHTAG = {
  hashtagNameKey: 'settings.dispaly.weekendVibes',
  hashtagId: '17843848510050108',
  hashtagNameKeyEditorX: 'settings.dispaly.lifestyle',
  hashtagIdEditorX: '178438485100501082',
};
export const MAX_COUNT_HASHTAG = 30;
export const MAX_COUNT_FEED = 40;
export const ERRORS = {
  INVALID_TOKEN: 403,
  INVALID_TOKEN_2: 190,
  INVALID_TOKEN_3: 401,
  NO_POSTS: 405,
  OLD_API: 444,
  GENERAL: 407,
};
export const EMPTY_ACCOUNT_HEIGHT = 300;
export const LOADING_MEDIAS_HEIGHT = 400;
export const LOADING_HASHTAG_HEIGHT = 200;

export const ERRORS_MESSAGE = {
  PASSWORD_CHANGED:
    'The session has been invalidated because the user changed their password',
  SESSION_EXPIRED: 'Session has expired on',
  NOT_CONFIRMED_USER:
    'Sessions for the user are not allowed because the user is not a confirmed user.',
  NOT_AUTHORIZED_APP: 'The user has not authorized application',
  NO_PERMISSION: 'Application does not have permission for this action',
  INVALID_AUTH: 'Invalid OAuth access token',
};

// Expand
export const DEFAULT_STORY_DURATION = 5000;

// BI
export const BUSINESS = 'business';
export const PERSONAL = 'personal';
export const SWITCH_TO_BUSINESS = 'switch_to_business';
export const CONNECT_ACCOUNT = 'Connect_account';
